exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".NotFoundView-content {\n  width: 45.83333%;\n  float: left;\n  margin-left: 2.08333%;\n  margin-right: 2.08333%;\n  margin-left: 27.08333%;\n  padding-top: 100px;\n  text-align: center; }\n\n.NotFoundView h1 {\n  font-weight: 200; }\n\n.NotFoundView-pathname {\n  padding: 3px 0.25em;\n  background: #e2e4e6;\n  color: #666b72;\n  font-family: Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n  font-size: 0.875em; }\n", ""]);

// exports
